import { z } from "zod";
import { FigmaComponentOrigin, FigmaComponentOriginPart, FigmaComponentPropertyMap } from "../elements";
import { ImportModelBase, ImportModelInputBase } from "./base";
import { FigmaSvgRenderImportModel, ImageImportModel } from "./image";

//
// Import model
//

const FigmaComponentImportModelPart = z.object({
  thumbnail: ImageImportModel,
  parentComponentId: z.string().optional(),
  componentPropertyDefinitions: FigmaComponentPropertyMap.optional(),
  variantPropertyValues: z.record(z.string()).optional(),
  renderNodeId: z.string(),
  svg: FigmaSvgRenderImportModel.optional(),
});

export const FigmaComponentImportModel = ImportModelBase.extend(FigmaComponentImportModelPart.shape).extend({
  origin: FigmaComponentOrigin,
  isAsset: z.boolean(),
});

export type FigmaComponentImportModel = z.infer<typeof FigmaComponentImportModel>;

//
// Import model input
//

export const FigmaComponentImportModelInput = ImportModelInputBase.extend(FigmaComponentImportModelPart.shape).extend({
  originMetadata: FigmaComponentOriginPart,
  isAsset: z.boolean().optional(),
});

export const AssetImportModelInput = FigmaComponentImportModelInput;

export type FigmaComponentImportModelInput = z.infer<typeof FigmaComponentImportModelInput>;
export type AssetImportModelInput = z.infer<typeof AssetImportModelInput>;
